import { createContext } from 'react';
import { GetSecuritiesQuotesParams } from '@goldwasserexchange/actor/rest-services';

export const securityQuotesParamsContext = createContext<Partial<GetSecuritiesQuotesParams>>({});
